import Button from '@mui/material/Button';
import type { OptionsMap } from '@openx/types/options';
import { type JSX, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTargetingContext } from '../../utils/context/TargetingContext';
import { OptionsDropdown } from '../shared/OptionsDropdown/OptionsDropdown';
import { DrawerTopBox } from '../shared/TargetingDrawer/DrawerTopBox';
import { filterOptions, getAllowedSortedIds } from './utils';

type TopBoxProps = {
  items: Set<string>;
  onChange: (categories: Set<string>) => void;
  handleReset: () => void;
  shouldDisplayResetButton: boolean;
};

export const CategoryTopBox = ({
  items,
  onChange,
  handleReset,
  shouldDisplayResetButton,
}: TopBoxProps): JSX.Element => {
  const { t } = useTranslation();
  const { useCategoriesFetch } = useTargetingContext();
  const { isCategoriesLoading, categories, refetchCategories } = useCategoriesFetch();

  useEffect(() => {
    refetchCategories();
  }, [refetchCategories]);

  return (
    <DrawerTopBox sx={{ padding: theme => theme.spacing(0, 3, 1) }}>
      <OptionsDropdown
        loading={isCategoriesLoading}
        options={categories}
        onChange={onChange}
        selectedOptions={items}
        placeholder={t('[ Select or Search IAB Categories ]')}
        label={t('Category')}
        dataTest="category-input"
        getSortedKeys={getAllowedSortedIds as (options: OptionsMap) => string[]}
        filterOptions={
          filterOptions as (optionsIds: string[], optionsMap: OptionsMap, searchPhrase: string) => string[]
        }
        margin="dense"
      />

      {shouldDisplayResetButton && (
        <Button
          data-test="reset-to-account-settings"
          onClick={handleReset}
          variant={'text'}
          color={'primary'}
          sx={{ marginTop: theme => theme.spacing(1) }}
        >
          {t("Reset to account's settings")}
        </Button>
      )}
    </DrawerTopBox>
  );
};
